"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelTestPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const use_promise_1 = require("../../../../../hook/use-promise");
const level_1 = require("../../../../../network/level");
const fetch_result_renderer_1 = require("../../../../../component/fetch-result-renderer");
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const button_1 = require("../../../../../component/input/button");
const log_1 = require("../../../../../model/log");
const log_view_layout_1 = require("../../../../../component/log-view-layout");
exports.LevelTestPage = (0, react_1.memo)(() => {
    const { result, error, status } = (0, use_promise_1.usePromise)(level_1.getLevelTestResult);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onGoToList = (0, react_1.useCallback)(() => {
        navigate("/list");
    }, [navigate]);
    return ((0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.LevelTestResultPage, children: (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: result, errorMessages: error === null || error === void 0 ? void 0 : error.message, status: status, sx: {
                height: "100%",
                width: "100%",
            }, children: (data) => ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 4, width: "100%", minHeight: "100%", padding: 8, alignItems: "center", justifyContent: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", fontWeight: "bold", color: "tertiary", children: "Hooray! You did it!​" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", color: "tertiary", children: `You are at level ${data}.` }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", color: "primary", eventName: log_1.LogEventClickName.QuizResultStartReading, onClick: onGoToList, children: "Let’s start Reading" })] })) }) }));
});
exports.LevelTestPage.displayName = "LevelTestPage";
exports.default = exports.LevelTestPage;
